var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennisdetable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.5,50c-0.3-3.1-1.9-5.9-4.3-7.8c-1.2-0.9-2.5-1.6-3.9-2.1c-1.6-10.3-8.2-16.5-8.5-16.7c0,0-6.6-5.3-6.7-5.4           c-0.2-0.1-4.1-2.9-10.3-4.2c-5.7-1.2-14.3-1.3-23.3,5.1c-7.8,5.5-13.8,12.2-17,19.4c-3.8,8.4-3.9,14.2-0.1,22.7           c2.3,5.3,4,9.8-0.5,15.7c-5.7,7.5-9.4,11.1-11.8,13.5c-0.5,0.5-1,1-1.4,1.4c-1.7,1.8-3.3,3.8-3.2,6.1c0.1,1.6,1,3.1,2.6,4.4l3.6,2.9           c1.4,1.1,3,1.9,4.9,1.6c2.3-0.3,3.9-2.3,5.3-4.4c0.3-0.5,0.7-1.1,1.1-1.8c1.9-3,5-8,11.2-15.2c4.5-5.3,8.2-4.5,13.7-3.4           c2.2,0.5,4.3,0.9,6.2,1.1c4.6,0.4,9.8-1.1,14.9-4.5c5.4-3.6,10.3-9,14-15.8c4.9,0.8,8.7-1.4,10.9-4.2C104.9,56.1,105.8,53.1,105.5,50z           M40.8,83.3c-7.1,8.2-12.2,16.8-12.5,17.3c-0.9,1.4-2.1,2.9-3.2,3.1c-0.7,0.1-1.5-0.2-2.4-1l-3.6-2.9c-0.9-0.8-1.5-1.5-1.5-2.2           c-0.1-1.2,1.1-2.6,2.3-3.8c0.4-0.4,7.2-6.8,13.4-15.2c4.3-5.9,3.9-10.5,2.3-15.2L54,78.2C49.6,77.6,45.4,78.1,40.8,83.3z           M63.4,79.9c-1-0.1-2-0.2-2.9-0.4L33.3,57.6c-0.3-0.9-0.7-1.8-1-2.7c-1.3-4.1-0.6-9.7,1.9-15.3C36.4,35,41,28,50.3,21.5           c6.5-4.5,13.5-6.1,20.8-4.6c5.3,1.1,8.8,3.4,9.2,3.7l6.4,5.2c0.4,0.4,5.8,5.6,7.4,13.9c-3.6-0.1-7,1.6-9.3,4.3           c-4,5-3.2,12.3,1.8,16.4c0.7,0.6,1.5,1.1,2.4,1.5C81.3,75.2,70.4,80.6,63.4,79.9z M100.6,56.6c-1.6,2-4.1,3.2-6.7,3.2           c-2,0-3.8-0.7-5.4-1.9c-3.7-3-4.3-8.4-1.3-12c1.6-2,4.1-3.2,6.7-3.2c2,0,3.8,0.7,5.4,1.9c1.8,1.4,2.9,3.5,3.1,5.7           C102.6,52.6,102,54.8,100.6,56.6z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisdetable);
export default __webpack_public_path__ + "static/media/tennisdetable.f2dc30e02a13a8551cfc9760cbbf78ee.svg";
export { ForwardRef as ReactComponent };